import * as React from "react";
import { UitkCheckbox } from "uitk-react-switch";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { ViewMedium, Viewport, ViewSmall } from "bernie-view";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

enum WizardHotelFilterOptions {
  BUSINESS_FRIENDLY = "BUSINESS",
  FAMILY_FRIENDLY = "FAMILY",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_CANCELLATION = "FREE_CANCELLATION"
}

const WizardHotelFilterList = [
  {
    id: "travelerTypeBussiness",
    key: "businessFriendly",
    filterTypeKey: locKeys.filterBusinessFriendly,
    name: "travelerType",
    value: WizardHotelFilterOptions.BUSINESS_FRIENDLY
  },
  {
    id: "travelerTypeFamily",
    key: "familyFriendly",
    filterTypeKey: locKeys.filterFamilyFriendly,
    name: "travelerType",
    value: WizardHotelFilterOptions.FAMILY_FRIENDLY
  },
  {
    id: "paymentTypeFreeCancellation",
    key: "freeCancellation",
    filterTypeKey: locKeys.filterFreeCancellation,
    name: "paymentType",
    value: WizardHotelFilterOptions.FREE_CANCELLATION
  },
  {
    id: "amenitiesFreeBreakfast",
    key: "breakfastIncluded",
    filterTypeKey: locKeys.filterBreakfastIncluded,
    name: "amenities",
    value: WizardHotelFilterOptions.FREE_BREAKFAST
  }
];

export const WizardHotelPWAFilter = ({
  checkboxFilterChecks,
  changeFormProperties
}: {
  checkboxFilterChecks: object;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
}) => {
  const { formatText } = useLocalization();
  const title = formatText(locKeys.filterTitle);

  return (
    <div className="uitk-cell">
      <UitkText size={300}>
        <div className="all-l-padding-one">{title}</div>
      </UitkText>
      <Viewport>
        <ViewSmall>
          <UitkLayoutGrid columns={2}>
            {WizardHotelFilterList.map(({ id, key, filterTypeKey, name, value }) => (
              <UitkLayoutGridItem>
                <UitkCheckbox
                  id={id}
                  name={name}
                  label={formatText(filterTypeKey)}
                  checked={checkboxFilterChecks[key]}
                  onChange={changeFormProperties}
                  value={value}
                  key={key}
                />
              </UitkLayoutGridItem>
            ))}
          </UitkLayoutGrid>
        </ViewSmall>
        <ViewMedium>
          <>
            {WizardHotelFilterList.map(({ id, key, filterTypeKey, name, value }) => (
              <div className="packageCheckbox all-r-padding-three">
                <UitkCheckbox
                  id={id}
                  name={name}
                  label={formatText(filterTypeKey)}
                  checked={checkboxFilterChecks[key]}
                  onChange={changeFormProperties}
                  value={value}
                  key={key}
                />
              </div>
            ))}
          </>
        </ViewMedium>
      </Viewport>
    </div>
  );
};
